import api from "../api";

export const nativeFieldsService = {
  fetchNativeFields: async () => {
    const res = await api.get(`/api/native-fields/`);
    return res.data;
  },
};
